import React from 'react'

const TermsCondition = () => {
  return (
    <section>
      <div className='container'>
        {' '}
        <div className='terms-conditions'>
          <h2>Terms and Conditions</h2>
          <div class='content'>
            <h3>Introduction</h3>
            <p>
              These Website Standard Terms and Conditions written on this web
              page shall manage your use of our website,
              <a href='https://wa-watchme.netlify.app/'>
                https://wa-watchme.netlify.app/
              </a>
            </p>
            <p>
              These Terms will be applied fully and affect your use of this
              Website. By using this Website, you agreed to accept all terms and
              conditions written in here. You must not use this Website if you
              disagree with any of these Website Standard Terms and Conditions.
              Minors or people below 18 years old are not allowed to use this
              Website.
            </p>
            <h3>Intellectual Property Rights</h3>
            <p>
              Other than the content you own, under these Terms, WatchMe and/or
              its licensors own all the intellectual property rights and
              materials contained in this Website. You are granted limited
              license only for purposes of viewing the material contained on
              this Website.
            </p>
            <h4>Restrictions</h4>
            <ul>
              You are specifically restricted from all of the following:
              <li>publishing any Website material in any other media;</li>
              <li>
                selling, sublicensing and/or otherwise commercializing any
                Website material
              </li>
              <li>publicly performing and/or showing any Website material</li>
              <li>
                using this Website to engage in any advertising or marketing
              </li>
              <li>
                using this Website in any way that impacts user access to this
                Website
              </li>
            </ul>
            <h3>Your Content</h3>
            <p>
              In these Website Standard Terms and Conditions, “Your Content”
              shall mean any audio, video text, images or other material you
              choose to display on this Website. By displaying Your Content, you
              grant TrailerSpice a non-exclusive, worldwide irrevocable, sub
              licensable license to use, reproduce, adapt, publish, translate
              and distribute it in any and all media. Your Content must be your
              own and must not be invading any third-party's rights.
              TrailerSpice reserves the right to remove any of Your Content from
              this Website at any time without notice.
            </p>
            <h3>No warranties</h3>
            <p>
              This Website is provided “as is,” with all faults, and
              TrailerSpice express no representations or warranties, of any kind
              related to this Website or the materials contained on this
              Website. Also, nothing contained on this Website shall be
              interpreted as advising you.
            </p>
            <p>
              These websites may collect data about you, use cookies, embed
              additional third-party tracking, and monitor your interaction with
              that embedded content, including tracking your interaction with
              the embedded content if you have an account and are logged in to
              that website.
            </p>
            <h4>Analytics</h4>
            <h3>How long we retain your data</h3>
            <p>
              If you leave a comment, the comment and its metadata are retained
              indefinitely. This is so we can recognize and approve any
              follow-up comments automatically instead of holding them in a
              moderation queue.
            </p>
            <p>
              For users that register on our website (if any), we also store the
              personal information they provide in their user profile. All users
              can see, edit, or delete their personal information at any time
              (except they cannot change their username). Website administrators
              can also see and edit that information.
            </p>
            <h3>What rights you have over your data</h3>
            <p>
              If you have an account on this site, or have left comments, you
              can request to receive an exported file of the personal data we
              hold about you, including any data you have provided to us. You
              can also request that we erase any personal data we hold about
              you. This does not include any data we are obliged to keep for
              administrative, legal, or security purposes.
            </p>
            <h3>Where we send your data</h3>
            <p>
              Visitor comments may be checked through an automated spam
              detection service.
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default TermsCondition
